import { Tabs } from 'platform-components';
import React, { ReactElement, RefObject } from 'react';

import './spec-course-lesson-view__tabs.scss';

interface Props {
    children: ReactElement | Array<ReactElement | null> | null;
    tabsRef?: RefObject<HTMLDivElement>;
}

export const SpecCourseLessonViewTabs = ({ children, tabsRef }: Props) => {
    return (
        <Tabs mix="spec-course-lesson-view__tabs" tabsRef={tabsRef} withDivider={true}>
            {children}
        </Tabs>
    );
};
